import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';
import RolSelect from './RolSelect';
import RoleForm from './RolForm';
import Modal from '../../../shared/Modal';
import DeleteModal from '../../contacts/utils/DeleteModal';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const Toolbar = (props) => {
    const buttonBase =
        `w-full sm:w-auto sm:mt-20 whitespace-nowrap px-4 py-2 text-sm border rounded transition
        ${props.loading ? 'bg-purple-200 text-white border-transparent cursor-not-allowed' :
            'bg-personalized text-white border-transparent hover:bg-white hover:text-personalized hover:border-personalized'
        }`;

    return (
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
            <RolSelect
                roles={props.roles}
                role={props.selectedRole}
                setRole={props.setRole}
                setPermissionsSave={props.setPermissionsSave}
            />
            {props.isEditor && (
                <AsyncButton
                    className={buttonBase}
                    onClick={props.handleCreateRole}
                    disabled={props.loading}
                >
                    Crear rol
                </AsyncButton>
            )}
            {props.isEditor && props.selectedRole && (
                <>
                <AsyncButton
                    className={buttonBase}
                    onClick={props.handleEditRole}
                    disabled={props.loading}
                >
                    Editar rol
                </AsyncButton>
                <AsyncButton
                    className={buttonBase}
                    onClick={props.askDelete}
                    disabled={props.loading}
                >
                    Eliminar rol
                </AsyncButton>
                <button
                    className={buttonBase}
                    onClick={props.changeSave}
                    disabled={props.loading}
                >
                    <ButtonLoadingContent loading={props.loading}>
                        Guardar cambios de permisos
                    </ButtonLoadingContent>
                </button>
                </>
            )}
            <Modal
                isOpen={props.openRoleModal}
                onClose={props.handleCloseRoleModal}
                title={props.roleModalMode === 'create' ? 'Crear rol' : 'Editar rol'}
                closeActive={!props.loading}
            >
                <RoleForm
                    name={props.roleName}
                    onChange={props.handleRoleFormChange}
                    onSave={props.handleSaveRole}
                    onClose={props.handleCloseRoleModal}
                    loading={props.loading}
                    mode={props.roleModalMode}
                />
            </Modal>
            <DeleteModal
                confirm={props.confirm}
                closeActive={true}
                onClose={props.closeDeleteModal}
                onConfirm={props.handleConfirmDelete}
            />
        </div>
    );
};

export default Toolbar;
